import { colors }        from 'utils/colors';
import { connect }       from 'react-redux';
import { reducerType }   from 'reducer';
import { sizeStateType } from 'reducer/types';


// const zoom     = `הצטרפו לקבוצה השקטה של יישומטיקה:`
// const zoomLink = "https://chat.whatsapp.com/D58EF9PX1ai1MwZB2t5CNO"


type ZoomMessageProps = { 
  classes:     any; 
  buttonStyle: any; 
  variant:     number;
  text:        string;
  link:        string;
  buttonText:  string;
  sizeState:   sizeStateType 
}

const ZoomMessage: React.FC<ZoomMessageProps> = ({
  classes, 
  sizeState, 
  variant, 
  text, 
  link, 
  buttonText, 
  buttonStyle 
}) => {

  return (
        <>
            {/* <div>
              { zoomT }
            </div> */}
            <div style = {{ fontSize: !sizeState.wideScreen ? 12 : undefined }}>
              { text }
            </div>
            <a
              className = { variant === 1 ? classes.button : classes.button2 }
              href      = { link }
              target    = "_blank"
              rel       = "noreferrer"
              style     = {{
                ...buttonStyle,
                textDecoration:  'none',
                backgroundColor: colors.teacherLessons
              }}
            >
              { buttonText }
            </a>
        </>
                 
  );
}


const mapStateToProps = (reducer: reducerType) => {
  return {
     sizeState: reducer.size
  }};


export default connect(mapStateToProps)(ZoomMessage);

